import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { PayrollComparisonReportDocument } from '../../../../models/accounting/shared/payroll-comparison-report-document';

export const PayrollComparisonReport = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setIsOpen(false);
    };

    /**
     * Format the dates and initiate the AccountMate report command
     */
    const runReport = () => {
        const req = new PayrollComparisonReportDocument();
        dispatch(getDocumentHelper(req));
        onCloseClick();
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Payroll Comparison</h3>
                                <p>Get a collection or reports comparing the current payroll process with the upcoming Bonus Structure</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <DialogTrigger
                                    onClick={onOpenClick}
                                    text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                className="report-dialog"
                onClose={onCloseClick}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Payroll Comparison REport</h1>
                </DialogHeader>

                <DialogContent>
                    
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="accountmateNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={onCloseClick} />
                    <FlatButton
                        id="accountmateYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={runReport} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
